import { useState } from "react";
import { Col, Row, Button } from "antd";
import type { MenuProps } from "antd";
import AddActionModal from "components/common/AddActionModal";
import { stringConfig } from "config/site.string";
import { BaseButtonsForm } from "components/common/forms/BaseButtonsForm";
import MicrosoftIcon from "components/common/MicrosoftIcon";
import { msalConfig } from "authConfig";
import { loadState } from "library/helpers/sessionStorage";
import { useNavigate } from "react-router-dom";
import { resetOnLogout } from "redux/users/actions";
import { useDispatch } from "react-redux";
import { resetMasterDataReducer } from "redux/masterData/actions";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { PublicClientApplication } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import AccountSettings from "./AccountSettings";
import * as S from "./styles";
import { Dropdown } from "../../common/Dropdown/Dropdown.styles";

export const ProfileDropdown = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = BaseButtonsForm.useForm();
  const [selectedRecord, setSelectedRecord] = useState<any>("");
  const msalInstance = new PublicClientApplication(msalConfig);
  const { instance } = useMsal();
  const userInfoLocalStorage = loadState("userInfo");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = async () => {
    if (userInfoLocalStorage?.isMicrosoftUser) {
      localStorage.clear();
      sessionStorage.clear();
      msalInstance.setActiveAccount(null);
      await instance.logoutRedirect({
        postLogoutRedirectUri: "/",
      });
      dispatch(resetOnLogout());
      dispatch(resetMasterDataReducer());
    } else {
      dispatch(resetOnLogout());
      dispatch(resetMasterDataReducer());
      localStorage.clear();
      sessionStorage.clear();
      navigate("/");
    }
  };

  const items: MenuProps["items"] = [
    {
      key: "my-account",
      label: "My Account",
      icon: <UserOutlined style={{ cursor: "pointer" }} />,
    },
    {
      key: "logout",
      icon: <LogoutOutlined style={{ cursor: "pointer" }} />,
      label: "Logout",
      onClick: handleLogout,
    },
  ];

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const onClick: MenuProps["onClick"] = ({ key }) => {
    if (key === "my-account") {
      setSelectedRecord({
        email: userInfoLocalStorage?.email,
        firstName: userInfoLocalStorage?.firstName,
        lastName: userInfoLocalStorage?.lastName,
        role: userInfoLocalStorage?.role,
        customers: userInfoLocalStorage?.customers,
        vendors: userInfoLocalStorage?.vendors,
      });
      form.setFieldsValue({
        email: userInfoLocalStorage?.email,
        firstName: userInfoLocalStorage?.firstName,
        lastName: userInfoLocalStorage?.lastName,
      });
      setIsModalOpen(true);
    }
  };

  return (
    <>
      <Dropdown
        menu={{ items, onClick }}
        trigger={["click"]}
        overlayStyle={{ width: 150 }}
      >
        <S.ProfileDropdownHeader as={Row} gutter={[10, 10]} align="middle">
          <Col>
            <Button
              type="primary"
              shape="circle"
              className="profile-icon"
              icon={<MicrosoftIcon style={{ fontSize: "18px" }} />}
            ></Button>
          </Col>
        </S.ProfileDropdownHeader>
      </Dropdown>
      {isModalOpen && (
        <AddActionModal
          title={stringConfig.accountSettings}
          isModalOpen={isModalOpen}
          handleOk={handleOk}
          handleCancel={handleCancel}
          cancelText={stringConfig.cancel}
          saveText={stringConfig.submit}
          pending={false}
          className="account-settings-modal"
          formName="user"
          isClose={true}
        >
          <AccountSettings
            form={form}
            isAccount={true}
            selectedRecord={selectedRecord}
          />
        </AddActionModal>
      )}
    </>
  );
};
